import React from 'react'
import { createSearchParams } from 'react-router-dom'

import { Box, Button, Text } from '@factorialco/deprecated-design-system'

import { useNavigation } from 'modules/core/hooks/useNavigation'
import i18n from 'modules/core/lib/i18n'

import reviewTemplatesEmptyState from './images/reviewTemplatesEmptyState.png'
import './index.styles.css'
interface Props {
  canCreateReview?: boolean
}

export const ReviewsEmptyState: React.FC<Props> = ({ canCreateReview }) => {
  const { navigation } = useNavigation()

  return (
    <Box flexDirection="column" alignItems="center" overflowY="hidden" gap="s32">
      <Box flexDirection="column" gap="s24" alignItems="center">
        <Box flexDirection="column" gap="s8" alignItems="center" textAlign="center" maxWidth="s600">
          <Text.Header2 weight="semibold" color="grey800">
            {i18n.t('performance_process.reviews.empty_state.title')}
          </Text.Header2>
          <Text.Normal>{i18n.t('performance_process.reviews.empty_state.description')}</Text.Normal>
        </Box>
        {canCreateReview && (
          <Box flexDirection="row" gap="s16">
            <Button.Router
              to={{
                pathname: navigation.performanceProcess.reviews.fullPath(),
                search: createSearchParams({ modal: 'select' }).toString(),
              }}
              iconName="add"
              type="secondary"
            >
              {i18n.t('performance_process.reviews.new_review')}
            </Button.Router>
          </Box>
        )}
        {/* TODO: uncomment when link is available */}
        {/* <Link.Href href="">How should I measure performance?</Link.Href> */}
      </Box>
      <Box className={'ReviewsEmptyState_imageContainer'}>
        {/* eslint-disable-next-line factorial/no-raw-html */}
        <img className={'ReviewsEmptyState_image'} src={reviewTemplatesEmptyState} />
      </Box>
    </Box>
  )
}
